import {
  GATEWAY_TRANSFER_CONFIRMATION_START,
  GATEWAY_TRANSFER_CONFIRMATION_SUCCESS,
  GATEWAY_TRANSFER_CONFIRMATION_ERROR,
  CLEAR_GATEWAY_TRANSFER_CONFIRMATION_SUCCESS,
} from 'constants/action-types/moneyTransfer';

export default (state, { type, payload }) => {
  switch (type) {
    case GATEWAY_TRANSFER_CONFIRMATION_START:
      return {
        ...state,
        gatewayTransactionConfirmation: {
          ...state.gatewayTransactionConfirmation,
          loading: true,
          error: null,
        },
      };
    case GATEWAY_TRANSFER_CONFIRMATION_ERROR:
      return {
        ...state,
        gatewayTransactionConfirmation: {
          ...state.gatewayTransactionConfirmation,
          error: payload,
          loading: false,
        },
      };
    case GATEWAY_TRANSFER_CONFIRMATION_SUCCESS:
      return {
        ...state,
        gatewayTransactionConfirmation: {
          ...state.gatewayTransactionConfirmation,
          error: null,
          loading: false,
          data: payload,
        },
      };
    case CLEAR_GATEWAY_TRANSFER_CONFIRMATION_SUCCESS: {
      return {
        ...state,
        gatewayTransactionConfirmation: {
          ...state.gatewayTransactionConfirmation,
          error: null,
          loading: false,
          data: null,
        },
      };
    }
    default:
      return null;
  }
};
